import { Grid } from '@material-ui/core'
import styled from 'styled-components'

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  width: 100%;
`
export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const StyledGrid = styled(Grid)`
  margin-bottom: 20px;
`
